module.exports = __webpack_public_path__ + "img/5-Intersection 2.184883ca.png";